module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/VG1003-41b0d189011fbc4ebbdd884e1d623c3a.png";